import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LANDMARK_CREATE } from '../../../component/management-tab/landmarks-sub-tab/landmarks-routing.constants';
import { Landmark } from '../../../database/models';
import { LayoutService } from '../../../services/layout.service';
import { MapService } from '../../../services/map.service';
import { RoutingService } from '../../../services/routing.service';
import { ViewService } from '../../../services/view.service';
import HasPermissionDirective from '../../../utils/directives/has-permission.directive';
import DurationPipe from '../../../utils/pipes/duration.pipe';
import ImperialPipe from '../../../utils/pipes/imperial.pipe';
import { MISSION_CREATE } from '../../mobility-tab/missions-sub-tab/missions-routing.constants';
import type { MissionsView } from '../../mobility-tab/missions-sub-tab/missions/missions.component';

@Component({
  selector: 'map-action',
  templateUrl: './map-action.component.html',
  styleUrl: './map-action.component.scss',

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButtonModule,
    MatIconModule,
    TranslatePipe,
    MatDividerModule,
    MatTooltipModule,
    HasPermissionDirective,
    ImperialPipe,
    DurationPipe,
  ],
})
export class MapActionComponent {
  public mapService = inject(MapService);
  public routingService = inject(RoutingService);
  public router = inject(Router);
  private viewService = inject(ViewService<MissionsView>);
  public layoutService = inject(LayoutService);

  public getInfoAround() {
    this.router.navigate(['/around']);
    this.mapService.chosenPoi = Object.assign(Object.create(Landmark.prototype), {
      street: this.mapService.clickPos.street,
      city: this.mapService.clickPos.city,
      longitude: this.mapService.clickPos.lon,
      latitude: this.mapService.clickPos.lat,
    }) as Landmark;
    this.mapService.fitOn(this.mapService.chosenPoi.latitude, this.mapService.chosenPoi.longitude);
    this.mapService.$onClickPosition.set(false);
    this.mapService.getClosestDeviceOrPoi('device', this.mapService.chosenPoi, 10, undefined, true);
    this.mapService.getClosestDeviceOrPoi('poi', this.mapService.chosenPoi, 10, undefined, true);
  }

  public switchDirectionActive() {
    this.mapService.$onClickDirection.set(true);
    this.mapService.direction.start = {
      lng: this.mapService.clickPos.lon,
      lat: this.mapService.clickPos.lat,
    };
  }

  public generateMission() {
    const objPos = {
      longitude: Number(this.mapService.clickPos.lon.toFixed(5)), //Need with this name (not lon)
      latitude: Number(this.mapService.clickPos.lat.toFixed(5)), //Need with this name (not lat)
      addr: this.mapService.clickPos.addr,
      city: this.mapService.clickPos.city,
      street: this.mapService.clickPos.street,
      postcode: this.mapService.clickPos.postcode,
    };
    const poi = { poi: objPos, dest_prefix: '' };
    this.router.navigate([MISSION_CREATE], {
      queryParams: { destinations: JSON.stringify([poi]) },
    });
    this.viewService.changeView('map');
    this.mapService.$onClickPosition.set(false);
  }

  public closeDirection() {
    this.mapService.$onClickDirection.set(false);
    this.mapService.resetDirection();
  }

  public addPoi() {
    this.router.navigate([LANDMARK_CREATE], {
      queryParams: {
        long: this.mapService.clickPos.lon.toFixed(5),
        lat: this.mapService.clickPos.lat.toFixed(5),
      },
    });
    this.mapService.$onClickPosition.set(false);
  }

  public closeMapAction() {
    this.mapService.removePosition();
  }
}
